import Vue from 'vue';

import axios    from 'axios';
import VueAxios from 'vue-axios';

const eSailServerUrl = "https://esail-server.herokuapp.com/api/"
// const eSailServerUrl = "https://esail-server-develop.herokuapp.com/api/"
// const eSailServerUrl = "http://localhost:8080/api/"

axios.defaults.baseURL = eSailServerUrl

Vue.use(VueAxios, axios);

export default VueAxios;

export const eSailServerPublic = axios.create({
    baseURL: eSailServerUrl,
})

export const eSailServerAuth = axios.create({
    baseURL: eSailServerUrl,
    headers: {
        Authorization: 'Bearer {token}'
    }
})
